import { BarChart } from '@mantine/charts';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React, { useMemo } from 'react';
import { AdminStatsDailyPointDto } from 'src/api/FiretrolApiClient';
import { formatDate } from 'src/utils';

export interface ISqlHealthChartProps {
  daily: AdminStatsDailyPointDto[];
}

export const SqlHealthChart: React.FC<ISqlHealthChartProps> = ({ daily }) => {
  const data = useMemo(
    () =>
      daily.map((point) => ({
        date: formatDate(point.date, 'MM/DD'),
        Accepted: point.sqlAcceptedCount,
        Rejected: point.sqlRejectedCount,
      })),
    [daily],
  );

  return (
    <Stack gap={4}>
      <Text size="xs" fw={600} tt="uppercase" c="gray.7">
        Daily accepted vs rejected
      </Text>
      <BarChart
        h={220}
        data={data}
        dataKey="date"
        type="stacked"
        series={[
          { name: 'Accepted', color: 'green' },
          { name: 'Rejected', color: 'red' },
        ]}
        tickLine="y"
        gridAxis="xy"
        withLegend
      />
    </Stack>
  );
};
